'use client';

import { classes } from '@/components/Shared/DataList';
import { DataListSkeleton } from '@/components/Shared/DataListSkeleton';
import { LoadingAlert } from '@/components/Shared/LoadingAlert';
export function TableAttributesSkeleton() {
  return <div className="p-5 bg-white">
      <LoadingAlert title="Fetching attributes" />

      <div className={classes.wrapper}>
        <DataListSkeleton length={4} />
      </div>
    </div>;
}